import React from 'react';
import { Grid } from '@material-ui/core';
import { observer } from 'mobx-react';
import { useFormikContext } from 'formik';
import { paymentMethod } from '@ourbranch/lookups';

import { useStore } from 'core/store/store.mobx';
import { FormField } from 'core/components/form';
import useSession from 'core/hooks/use-session';
import { UpdateBillToOtherNotification } from 'common/components/mortgage-details';
import { StripeCustomerIdField } from '../stripe-customer-id-field';
import { useNormalizePaymentMethod } from '../hooks/use-normalize-payment-method';
import useStyles from '../billing-details-form.styles';
import { SecondaryPaymentMethod } from '../secondary-payment-method';

const BillToOther = () => {
  const classes = useStyles();
  const { viewOnly } = useSession();
  const { values } = useFormikContext();
  const {
    account: {
      policies: { policy }
    }
  } = useStore();

  // farmInterestedParties was hydrated into Formik values from the store's flattened
  // `policyDetails`. Fall back to `additionalParties` for non-Farm contexts.
  const billToOtherParty =
    values.farmInterestedParties?.find((party) => party.relationship === 'billToOther') ||
    policy.additionalParties?.find((party) => party.relationship === 'billToOther');

  useNormalizePaymentMethod(paymentMethod.BillToOther);

  return (
    <>
      <Grid container className={classes.billingDetailsContainer} spacing={4}>
        <StripeCustomerIdField />
      </Grid>
      <Grid container justifyContent="flex-start" className={classes.billingDetailsContainer} spacing={4}>
        <FormField
          type="value"
          label="Bill to other name or company"
          mode="dark"
          xs={6}
          value={billToOtherParty?.name ? billToOtherParty?.name : 'Not provided'}
        />
        <FormField
          type="value"
          label="Bill to other address"
          xs={6}
          mode="dark"
          value={
            billToOtherParty?.address
              ? `${billToOtherParty?.address.address}, ${billToOtherParty?.address.city}, ${billToOtherParty?.address.state}, ${billToOtherParty?.address.zip}`
              : 'Not provided'
          }
        />
        <FormField
          type="value"
          label="Bill to other email"
          xs={6}
          mode="dark"
          value={billToOtherParty?.email || 'Not provided'}
        />

        <Grid item xs={12}>
          <UpdateBillToOtherNotification
            isBillToOtherAdded={!!billToOtherParty?.name}
            onNavigateToDetails={() => {
              policy.setScrollTo('additionalParties');
            }}
          />
          {!viewOnly && <SecondaryPaymentMethod />}
        </Grid>
      </Grid>
    </>
  );
};

export default observer(BillToOther);
